export async function subscreverPush(publicKey, token, idutilizador) {
  console.log("subscreverPush chamada");

  try {
    if (!("serviceWorker" in navigator)) {
      console.log("Service Worker não suportado neste browser.");
      return;
    }

    const reg = await navigator.serviceWorker.ready;

    console.log("Service Worker pronto para Push:", reg);

    let subscription = await reg.pushManager.getSubscription();

    if (!subscription) {
      console.log("Sem subscrição existente. A criar nova subscrição Web Push...");

      subscription = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicKey),
      });
    } else {
      console.log("Subscrição Web Push existente encontrada:", subscription);
    }

    console.log("Subscrição Web Push a enviar para API:", subscription);

    // enviar para API
    const resp = await fetch("/api/Chats/GuardarWebPushSubscription", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        idutilizador,
        endpoint: subscription.toJSON().endpoint,
        p256dh: subscription.toJSON().keys?.p256dh,
        auth: subscription.toJSON().keys?.auth,
        useragent: navigator.userAgent,
        devicelabel: getDeviceLabel(),
        browser: getBrowserName(),
        platform: getPlatformName(),
      }),
    });

    if (!resp.ok) {
      throw new Error(`Erro HTTP ao guardar subscrição: ${resp.status}`);
    }

    const json = await resp.json();

    if (json?.success === false) {
      throw new Error(json.message || "Erro ao guardar subscrição.");
    }

    console.log("Subscrição Web Push guardada com sucesso", json);
  } catch (err) {
    console.error("Erro subscrição push:", err);
  }
}

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");

  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
}

function getPlatformName() {
  const ua = navigator.userAgent || "";

  if (/Android/i.test(ua)) return "Android";
  if (/iPhone|iPad|iPod/i.test(ua)) return "iOS";
  if (/Windows/i.test(ua)) return "Windows";
  if (/Macintosh|Mac OS X/i.test(ua)) return "Mac";
  if (/Linux/i.test(ua)) return "Linux";

  return "Desconhecido";
}

function getBrowserName() {
  const ua = navigator.userAgent || "";

  if (/Edg\//i.test(ua)) return "Edge";
  if (/OPR\//i.test(ua) || /Opera/i.test(ua)) return "Opera";
  if (/Chrome\//i.test(ua) && !/Edg\//i.test(ua) && !/OPR\//i.test(ua)) return "Chrome";
  if (/Firefox\//i.test(ua)) return "Firefox";
  if (/Safari\//i.test(ua) && !/Chrome\//i.test(ua)) return "Safari";

  return "Desconhecido";
}

function getDeviceLabel() {
  const platform = getPlatformName();
  const browser = getBrowserName();

  return `${platform} - ${browser}`;
}
